import { useState, useEffect } from "react";
import { Table, Card, CardHeader, CardTitle } from "reactstrap";
import Select from "react-select";
import { H5 } from "../../../../AbstractElements";
import { PharmacyPaymentList, NetProfitList } from "../../../../apiController";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DataTable from "react-data-table-component";

const PharmacyIncome = () => {
    const [pharmancyIncomeList, setPharmancyIncomeList] = useState([]);
    const [modal, setModal] = useState(false);
    const [selectedMonthID, setSelectedMonthID] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Store selected year


    const toggle = (monthID) => {
        setSelectedMonthID(monthID);
        setModal(!modal);
    };

    const type = pharmancyIncomeList
        .filter((row) => ((row.month === selectedMonthID) && (row.year === selectedYear)))
        .flatMap((row) =>
            row.data.map((pharmancy, ind) => ({
                ind: ind + 1,
                id: pharmancy.id,
                invoice: pharmancy.invoice,
                patientName: pharmancy.patient_name,
                paidAmount: pharmancy.paid_amt,
            }))
        );

    const monthDataColumns = [
        { name: "#", selector: (row) => row.ind, sortable: true },
        {
            name: "Invoice",
            selector: (row) => row.invoice,
            sortable: true,
            center: true,
        },
        {
            name: "Patient Name",
            selector: (row) => row.patientName,
            sortable: true,
            center: true,
        },
        {
            name: "Paid Amount",
            selector: (row) => row.paidAmount,
            sortable: true,
            center: true,
        },
    ];

   
    const options = [{ value: 2024, label: 2024 }, { value: 2023, label: 2023 }];

    const tableHeader = ["#", "Month", "Total"];
    const months = [
        { id: 1, month: "January" },
        { id: 2, month: "February" },
        { id: 3, month: "March" },
        { id: 4, month: "April" },
        { id: 5, month: "May" },
        { id: 6, month: "June" },
        { id: 7, month: "July" },
        { id: 8, month: "August" },
        { id: 9, month: "September" },
        { id: 10, month: "October" },
        { id: 11, month: "November" },
        { id: 12, month: "December" },
    ];

    useEffect(() => {
        fetchPharmancyIncomeList();
    }, []);

    const fetchPharmancyIncomeList = async () => {
        const response = await PharmacyPaymentList();
        const responseNet = await NetProfitList();
        if (response.status === true) {
            setPharmancyIncomeList(response.sum.reverse());
        }
    };

    return (
        <Card>
            <CardHeader className="d-flex gap-4 justify-content-evenly align-items-center">
                <CardTitle>Select Year</CardTitle>
                <Select
                    options={options}
                    className="js-example-basic-single col-sm-3"
                    value={options.find(option => option.value === selectedYear)}
                    onChange={(option) => setSelectedYear(option.value)} 
                />
                <H5 className="align-self-end">Pharmacy Income</H5>
            </CardHeader>
            <Table responsive striped>
                <thead>
                    <tr className="text-center">
                        {tableHeader.map((heads, i) => (
                            <th key={i}>{heads}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {months.map((data) => (
                        <tr className="text-center" key={data.id}>
                            <td>{data.id}</td>
                            <td>
                                <span
                                    onClick={() => toggle(data.id)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {data.month}
                                </span>
                            </td>
                            <td>
                                {pharmancyIncomeList
                                    .filter((main) => ((main.month === data.id) && (main.year === selectedYear)))
                                    .map((main, index) => (
                                        <span key={index}>{main.prescription_payment || "--"}</span>
                                    ))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Modal isOpen={modal} toggle={() => toggle(null)} size="lg" centered>
                <ModalHeader toggle={() => toggle(null)}>
                    Details for{" "}
                    {months.find((m) => m.id === selectedMonthID)?.month || "N/A"}
                </ModalHeader>
                <ModalBody>
                    <DataTable
                        data={type}
                        columns={monthDataColumns}
                        striped={true}
                        pagination
                        selectableRows
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => toggle(null)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Card>
    );
};

export default PharmacyIncome;
